<app-preloader *ngIf="(isLoading$ | async) === false"></app-preloader>

<ng-container *ngIf="isLoading$ | async">
    <app-element-placeholder
        *ngIf="!collection"
        class="loading-placeholder"
    ></app-element-placeholder>
    <ng-container *ngIf="collection">
        <div class="heading-wrapper">
            <app-heading
                [collectionSlug]="collectionSlug"
                [collection]="collection"
                [colorLogo]="collection.colorLogo"
                [hero]="collection.hero"
                [resourcesDescription]="collection.getResourceTypesDisplay()"
                [whiteLogo]="collection.whiteLogo"
            >
            </app-heading>
        </div>
        <section *ngIf="collection.hasFeaturedResources" class="section featured-section">
            <div class="container">
                <div class="section-title">
                    {{ collection.featuredSection.title }}
                </div>
                <div class="featured-section-description">
                    {{ collection.featuredSection.description }}
                </div>
                <div class="row-auto featured-resources featured-medium gtm-featured-resources">
                    <app-carousel2
                        [alwaysShowArrows]="false"
                        [innerArrows]="true"
                        [itemWidth]="300"
                        height="340"
                    >
                        <app-carousel-item2
                            *ngFor="
                                let learningObject of collection.featuredSection.learningObjects
                            "
                            class="carousel-item"
                        >
                            <app-resource-browse-card
                                [learningObject]="learningObject"
                                [listenToResize]="true"
                                [type]="'medium'"
                            ></app-resource-browse-card>
                        </app-carousel-item2>
                    </app-carousel2>
                </div>
                <div class="row-auto featured-resources featured-large gtm-featured-resources">
                    <app-carousel2
                        [alwaysShowArrows]="false"
                        [innerArrows]="true"
                        [itemWidth]="443"
                        height="450"
                    >
                        <app-carousel-item2
                            *ngFor="
                                let learningObject of collection.featuredSection.learningObjects
                            "
                            class="carousel-item"
                        >
                            <app-resource-browse-card
                                [learningObject]="learningObject"
                                [listenToResize]="true"
                                [type]="'large'"
                            ></app-resource-browse-card>
                        </app-carousel-item2>
                    </app-carousel2>
                </div>
            </div>
        </section>
        <section
            *ngFor="let section of collection.sections"
            class="section {{ 'by-' + buildCssSelector(section.label) }}"
        >
            <div class="container px-xs-0 px-md-4">
                <div class="section-title px-xs-4">
                    Browse Resources {{ section.preposition }} {{ section.label }}
                </div>
                <div
                    *ngIf="section.description"
                    [innerHTML]="section.description | bypassSecurity: 'html'"
                    class="section-description px-xs-4"
                ></div>
                <div *ngIf="section.cardType === 'mezzanine'" class="row-auto section-cards">
                    <app-mezzanine-collection-card
                        *ngFor="let sectionItem of section.items"
                        [item]="sectionItem"
                        [sectionName]="section.label"
                        [isPreviewMode]="isPreviewMode"
                        class="col-6 col-md-4 col-lg-3 mezzanine-card"
                    >
                    </app-mezzanine-collection-card>
                </div>
                <div *ngIf="section.cardType === 'overlay'" class="row-auto section-cards">
                    <app-overlay-collection-card
                        *ngFor="let sectionItem of section.items"
                        [item]="sectionItem"
                        [sectionName]="section.label"
                        [isPreviewMode]="isPreviewMode"
                        class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 overlay-card px-4"
                    >
                    </app-overlay-collection-card>
                </div>
            </div>
        </section>
        <app-premium-footer-links
            *ngIf="collection.footerSection?.showOnHomepage"
            [colors]="collection.colors"
            [footerSection]="collection.footerSection"
        ></app-premium-footer-links>
        <app-premium-footer-attributions
            [attributions]="footerAttributions"
            [credits]="collection.credits"
        ></app-premium-footer-attributions>
    </ng-container>
    <app-available-features></app-available-features>
</ng-container>
